var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-12"},[_vm._v("\n    Language\n    "),_c('span',{staticClass:"text-primary-light clickable",on:{"click":_vm.openLanguagePlaceholdersPage}},[_vm._v("\n        placeholders\n    ")]),_vm._v("\n    available\n")])}
var staticRenderFns = []

export { render, staticRenderFns }